import React from 'react'
import { history } from '../store'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { SubmissionError } from 'redux-form'

import Box from '../components/Box'

import { authLogin } from '../actions/auth'
import rateLimiter from '../utils/rateLimiter'

import LoginForm from '../forms/LoginForm'
import PasswordRecoveryForm from '../forms/PasswordRecoveryForm';

class LoginCustomerView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isRateLimited: false,
      rateLimitMessage: ''
    }

    this.submit = this.submit.bind(this)
    this.success = this.success.bind(this)
    this.checkRateLimit = this.checkRateLimit.bind(this)
  }

  componentDidMount() {
    this.checkRateLimit()
  }

  checkRateLimit() {
    if (rateLimiter.isRateLimited()) {
      this.setState({
        isRateLimited: true,
        rateLimitMessage: `Demasiados intentos fallidos. Por favor, espera ${rateLimiter.getFormattedTimeUntilReset()} antes de intentarlo de nuevo.`
      })
      
      // Check again after some time
      setTimeout(() => {
        this.checkRateLimit()
      }, 60000) // Check every minute
    } else {
      this.setState({
        isRateLimited: false,
        rateLimitMessage: ''
      })
    }
  }


  submit(props) {
    // Check rate limit before submitting
    if (rateLimiter.isRateLimited()) {
      this.checkRateLimit()
      return Promise.reject(new SubmissionError({
        _error: this.state.rateLimitMessage
      }))
    }

    return this.props.authLogin(props, false)
      .then(response => {
        if (response.error) {
          // Record failed attempt
          rateLimiter.recordAttempt()
          this.checkRateLimit()
          
          // Provide better error messages
          let errorMessage = response.error.message
          
          if (errorMessage.toLowerCase().includes('credentials') || 
              errorMessage.toLowerCase().includes('password') ||
              errorMessage.toLowerCase().includes('incorrect')) {
            errorMessage = 'Correo electrónico o contraseña incorrectos. Por favor, verifica tus credenciales.'
          } else if (errorMessage.toLowerCase().includes('not found') || 
                     errorMessage.toLowerCase().includes('no existe')) {
            errorMessage = 'No se encontró una cuenta con este correo electrónico.'
          } else if (errorMessage.toLowerCase().includes('blocked') || 
                     errorMessage.toLowerCase().includes('bloqueado')) {
            errorMessage = 'Tu cuenta ha sido bloqueada. Por favor, contacta con el soporte.'
          }
          
          throw new SubmissionError({
            _error: errorMessage,
            ...response.error.fields
          })
        }

        // Reset rate limiter on successful login
        rateLimiter.reset()
        return response
      })
  }

  success(result) {
    this.props.push('/')
  }

  render() {
    const { isRateLimited, rateLimitMessage } = this.state

    return (
      <div className="h-100 bg-login">
        <div className="container h-100">
          <div className="row justify-content-center align-items-center h-100">
            <div className="col pc">
              <div className="text-center mb-3">
                <img className="" src="/images/one_render.png" alt="VACWAYlockers" style={{width: '50%'}}/>
              </div>
            </div>
            <div className="col">
              <div className="text-center mb-3">
                <img className="login_logo" src="/images/logo.svg" alt="Logo" />
              </div>
              <div className="text-center mb-5">
                <h2 className="text-white">ONE & MINI</h2>
              </div>
              
              {isRateLimited && (
                <div className="alert alert-danger mb-4 text-center">
                  <strong>⚠️ Acceso temporalmente bloqueado</strong>
                  <p className="mb-0 mt-2">{rateLimitMessage}</p>
                </div>
              )}
              
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}>
                <LoginForm onSubmit={this.submit}
                  onSubmitSuccess={this.success} 
                  isAdmin={false}/>
              </div>
              <div className="d-flex justify-content-center mt-5">
                <div className="w-50 text-center">
                  <p className="text-white">Síguenos</p>
                  <div className="d-flex justify-content-between gap-4 flex-wrap mt-3">
                    <a href="https://vacway.com/es?utm_source=erp&utm_medium=login" target="_blank" rel="noopener noreferrer">
                      <img className="social_logo" src="/images/social/www.png" alt="Web" />
                    </a>
                    <a href="https://es.linkedin.com/company/vacway?utm_source=erp&utm_medium=login" target="_blank" rel="noopener noreferrer">
                      <img className="social_logo" src="/images/social/linkedin.png" alt="LinkedIn" />
                    </a>
                    <a href="https://www.instagram.com/vacway/?utm_source=erp&utm_medium=login" target="_blank" rel="noopener noreferrer">
                      <img className="social_logo" src="/images/social/instagram.png" alt="Instagram" />
                    </a>
                    <a href="https://www.tiktok.com/@vacway?utm_source=erp&utm_medium=login" target="_blank" rel="noopener noreferrer">
                      <img className="social_logo" src="/images/social/tiktok.png" alt="TikTok" />
                    </a>      
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  authLogin: bindActionCreators(authLogin, dispatch),
  push: bindActionCreators(push, dispatch)
})

export default connect(() => ({}), mapDispatchToProps)(LoginCustomerView)
